// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import {img_url} from '../ui/img_url';
import cn from 'classnames';
import styles from './stores_reviews.module.less';

const reviews = [
    // {
    //     platform: 'hola2023/review_trustpilot.svg',
    //     stars: 'hola2023/review_trustpilot_stars.svg',
    //     rating: '4.5',
    //     reviews_count: '1,300',
    // },
    {
        platform: 'hola2023/review_chrome_webstore.svg',
        rating: '4.9',
        reviews_count: '368,000',
    },
    {
        platform: 'hola2023/apple_store.svg',
        rating: '4.8',
        reviews_count: '7,000',
    },
    {
        platform: 'hola2023/google_store.svg',
        rating: '4.5',
        reviews_count: '2,800',
    }
];

const star_path = 'M20.7794 0.2619C20.9432 -0.0873001 21.448 -0.0873001'
    +' 21.6118 0.2619L23.1571 3.5561C23.2239 3.69842 23.3611 3.79641'
    +' 23.5193 3.81487L27.1832 4.242C27.5716 4.28728 27.7276 4.75929'
    +' 27.4404 5.02039L24.7316 7.48345C24.6146 7.58986 24.5622 7.74841'
    +' 24.5933 7.90214L25.3123 11.4603C25.3885 11.8375 24.9802 12.1292'
    +' 24.6389 11.9414L21.4195 10.1694C21.2804 10.0929 21.1108 10.0929'
    +' 20.9717 10.1694L17.7523 11.9414C17.411 12.1292 17.0026 11.8375'
    +' 17.0789 11.4603L17.7979 7.90214C17.829 7.74841 17.7766 7.58986'
    +' 17.6596 7.48345L14.9508 5.02039C14.6636 4.75929 14.8196 4.28728'
    +' 15.208 4.242L18.8718 3.81487C19.0301 3.79641 19.1673 3.69842'
    +' 19.2341 3.5561L20.7794 0.2619ZM5.97633 0.261961C6.14015 -0.087239'
    +' 6.6449 -0.087239 6.80871 0.261961L8.35405 3.55616C8.42081 3.69848'
    +' 8.55798 3.79647 8.71627 3.81493L12.3801 4.24206C12.7685 4.28734'
    +' 12.9245 4.75935 12.6373 5.02045L9.92857 7.48351C9.81154 7.58992'
    +' 9.75914 7.74848 9.79021 7.9022L10.5093 11.4604C10.5855 11.8376'
    +' 10.1771 12.1293 9.83584 11.9415L6.61639 10.1695C6.4773 10.093'
    +' 6.30775 10.093 6.16866 10.1695L2.9492 11.9415C2.60792 12.1293'
    +' 2.19957 11.8376 2.27579 11.4604L2.99484 7.9022C3.0259 7.74848'
    +' 2.97351 7.58992 2.85648 7.48351L0.147703 5.02045C-0.139439 4.75935'
    +' 0.0165373 4.28734 0.404922 4.24206L4.06877 3.81493C4.22706 3.79647'
    +' 4.36423 3.69848 4.431 3.55616L5.97633 0.261961ZM36.4168 0.2619C'
    +' 36.253 -0.0873001 35.7483 -0.0873001 35.5845 0.2619L34.0391 3.5561'
    +' C33.9724 3.69842 33.8352 3.79641 33.6769 3.81487L30.013 4.242C'
    +' 29.6247 4.28728 29.4687 4.75929 29.7558 5.02039L32.4646 7.48345C'
    +' 32.5816 7.58986 32.634 7.74841 32.603 7.90214L31.8839 11.4603C'
    +' 31.8077 11.8375 32.216 12.1292 32.5573 11.9414L35.7768 10.1694C'
    +' 35.9159 10.0929 36.0854 10.0929 36.2245 10.1694L39.444 11.9414C'
    +' 39.7852 12.1292 40.1936 11.8375 40.1174 11.4603L39.3983 7.90214C'
    +' 39.3673 7.74841 39.4197 7.58986 39.5367 7.48345L42.2455 5.02039C'
    +' 42.5326 4.75929 42.3766 4.28728 41.9882 4.242L38.3244 3.81487C'
    +' 38.1661 3.79641 38.0289 3.69842 37.9622 3.5561L36.4168 0.2619Z'
    +' M50.3875 0.2619C50.5513 -0.0873001 51.0561 -0.0873001 51.2199'
    +' 0.2619L52.7652 3.5561C52.832 3.69842 52.9692 3.79641 53.1275'
    +' 3.81487L56.7913 4.242C57.1797 4.28728 57.3357 4.75929 57.0485'
    +' 5.02039L54.3398 7.48345C54.2227 7.58986 54.1703 7.74841 54.2014'
    +' 7.90214L54.9204 11.4603C54.9967 11.8375 54.5883 12.1292 54.247'
    +' 11.9414L51.0276 10.1694C50.8885 10.0929 50.7189 10.0929 50.5798'
    +' 10.1694L47.3604 11.9414C47.0191 12.1292 46.6108 11.8375 46.687'
    +' 11.4603L47.406 7.90214C47.4371 7.74841 47.3847 7.58986 47.2677'
    +' 7.48345L44.5589 5.02039C44.2718 4.75929 44.4277 4.28728 44.8161'
    +' 4.242L48.48 3.81487C48.6383 3.79641 48.7754 3.69842 48.8422'
    +' 3.5561L50.3875 0.2619ZM66.023 0.2619C65.8592 -0.0873001 65.3544'
    +' -0.0873001 65.1906 0.2619L63.6453 3.5561C63.5785 3.69842 63.4413'
    +' 3.79641 63.283 3.81487L59.6192 4.242C59.2308 4.28728 59.0748'
    +' 4.75929 59.362 5.02039L62.0707 7.48345C62.1878 7.58986 62.2402'
    +' 7.74841 62.2091 7.90214L61.4901 11.4603C61.4138 11.8375 61.8222'
    +' 12.1292 62.1635 11.9414L65.3829 10.1694C65.522 10.0929 65.6916'
    +' 10.0929 65.8307 10.1694L69.0501 11.9414C69.3914 12.1292 69.7997'
    +' 11.8375 69.7235 11.4603L69.0045 7.90214C68.9734 7.74841 69.0258'
    +' 7.58986 69.1428 7.48345L71.8516 5.02039C72.1388 4.75929 71.9828'
    +' 4.28728 71.5944 4.242L67.9305 3.81487C67.7723 3.79641 67.6351'
    +' 3.69842 67.5683 3.5561L66.023 0.2619Z';

const Stars_svg = ({color}: {color: string})=>
    <svg width="72" height="12" viewBox="0 0 72 12" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d={star_path} fill={color}/>
    </svg>;

const Stars = ({rating}: {rating: number})=>{
    const fill_pct = `${rating / 5 * 100}%`;
    return <div className={styles.stars_wrapper}>
      <Stars_svg color="#ccc"/>
      <div className={styles.stars_fill} style={{width: fill_pct}}>
        <Stars_svg color="#32302F"/>
      </div>
    </div>;
};

const Review = (props: typeof reviews[0])=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.review}>
      <div>
        <img src={img_url(props.platform)} className={styles.platform} />
      </div>
      <div className={styles.rating}>
        <Stars rating={parseFloat(props.rating)} />
        <p className={cn([theme.p4, theme.med])}>
          {props.rating} | {props.reviews_count}+ reviews</p>
      </div>
    </div>;
};

interface i_stores_reviews_props {
    header: string;
}

export const Stores_reviews = ({header}: i_stores_reviews_props)=>{
    const {theme} = useContext(Settings_context);
    const header_text = header ? header :
        'Trusted by Millions of Users Worldwide';
    return <div className={styles.container}>
      <div className={theme.container}>
        <h4 className={styles.header}>{header_text}</h4>
        <h5 className={styles.header}>{header_text}</h5>
      </div>
      <div className={cn([styles.reviews, theme.container])}>
        {reviews.map((r, i)=><Review key={i} {...r}/>)}
      </div>
    </div>;
};

interface i_stores_reviews_editor_props {
    value: i_stores_reviews_props;
    on_change: (value: i_stores_reviews_props)=>void;
}

export const Stores_reviews_editor = ({value, on_change}:
i_stores_reviews_editor_props)=>{
    return <Editor value={value}
      on_change={on_change} editors={[
        {key: 'header', label: 'Header', type: 'text'},
    ]}/>;
};
